import { observer } from 'mobx-react-lite'
import { Platform, StyleSheet, Text, View } from 'react-native'
import { IconButton } from 'react-native-paper'

import { fontFamily } from '../../../theme'
import { IconButton as IconPress } from '../IconButton'

export interface TitleProps {
  title: string
  onClose: () => void
}

export const Title = observer(({ title, onClose }: TitleProps) => {
  return (
    <View style={styles.container}>
      <View style={styles.iconContainter}>
        <IconPress onPress={onClose}>
          <IconButton icon={'close'} iconColor="white" />
        </IconPress>
      </View>
      <View style={styles.textContainer}>
        <Text style={styles.text}>{title}</Text>
      </View>
    </View>
  )
})

const styles = StyleSheet.create({
  container: {
    display: 'flex',
    flexDirection: 'row',
    padding: 5,
    paddingTop: Platform.OS === 'android' ? 16 : 5
  },
  iconContainter: {
    maxWidth: '25%',
    justifyContent: 'center',
    alignItems: 'center'
  },
  textContainer: {
    maxWidth: '75%',
    justifyContent: 'center',
    alignItems: 'center',
    flex: 1
  },
  text: {
    fontWeight: '500',
    fontFamily: fontFamily.GTAmericaExtendedMedium,
    fontSize: 18,
    color: 'white',
    textAlign: 'center'
  }
})
